import styled from 'styled-components';

interface ShippingCountryWrapperProps {
  onClick: () => void;
}

const ShippingCountryWrapper = styled.div<ShippingCountryWrapperProps>`
  padding: 10px 0px 0;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export default ShippingCountryWrapper;
